import { createActions } from 'redux-actions';
import queryString from 'query-string';
import API from 'shared/constants/api';
// Setters

const DEFAULT_TRANSPORT_ID = 1;

export const partsFormActions = createActions({
  partsForm: {
    selected: {
      set: {
        transport: undefined,
        make: undefined,
        model: undefined,
        rubric: undefined,
        subRubric: undefined,
        yearFrom: undefined,
        yearTo: undefined,
        price: undefined,
        currency: undefined,
        contactName: undefined,
        email: undefined,
        location: undefined,
        sellingType: undefined,
        description: undefined,
        phones: undefined,
      },
      add: {
        photos: undefined,
        phones: undefined,
      },
      remove: {
        photos: undefined,
        phones: undefined,
      },
      toggle: {
        advertFields: undefined,
      },
    },
    vocabulary: {
      transports: undefined,
      makes: undefined,
      models: undefined,
      rubrics: undefined,
      subRubrics: undefined,
      currency: undefined,
      locations: undefined,
      company: undefined,
      typeWork: undefined,
      count: undefined,
      url: undefined,
      query: undefined,
      queryobj: undefined,
    },
    isEdit: undefined,
    clear: undefined,
  },
});

const { set } = partsFormActions.partsForm.selected;
export const setVocabularyField = partsFormActions.partsForm.vocabulary;

// Async actions
export const hrefSet = ({ query, url }) => dispatch => {
  const queryobj = Object.assign({}, query);
  if (query) {
    delete queryobj.fields;
    delete queryobj.per_page;

    dispatch(setVocabularyField.query(queryString.stringify(queryobj)));
    dispatch(setVocabularyField.queryobj(queryobj));
  }
  if (url) {
    dispatch(setVocabularyField.url(url.replace(/\/\//g, '/')));
  }
};
export const partsFormAsyncSetActions = {
  transport: transport => (dispatch, getState, { fetch }) => {
    dispatch(set.transport(transport));
    dispatch(partsFormAsyncSetActions.make(null));
    dispatch(partsFormAsyncSetActions.rubric(null));
    // dispatch(partsFormAsyncSetActions.company(null));
    dispatch(setVocabularyField.makes(null));
    dispatch(setVocabularyField.rubrics(null));
    // dispatch(setVocabularyField.company(null));

    if (transport) {
      return Promise.all([
        fetch(API.VOCABULARY.makes(transport.id))
          .then(r => r.json())
          .then(makes => dispatch(setVocabularyField.makes(makes))),
        fetch(API.VOCABULARY.rubrics(transport.id))
          .then(r => r.json())
          .then(rubrics => dispatch(setVocabularyField.rubrics(rubrics))),
      ]);
    }

    return Promise.resolve();
  },
  rubric: rubric => (dispatch, getState, { fetch }) => {
    dispatch(set.rubric(rubric));
    dispatch(set.subRubric(null));
    dispatch(setVocabularyField.subRubrics(null));

    if (rubric) {
      return fetch(API.VOCABULARY.rubrics(getState().partsForm.selected.transport.id, rubric.id))
        .then(r => r.json())
        .then(subRubrics => dispatch(setVocabularyField.subRubrics(subRubrics)));
    }

    return Promise.resolve();
  },
  make: make => (dispatch, getState, { fetch }) => {
    dispatch(set.make(make));
    dispatch(set.model(null));
    dispatch(setVocabularyField.models(null));
    const transport = getState().partsForm.selected.transport;
    const transportId = (transport && transport.id) || DEFAULT_TRANSPORT_ID;

    if (make && make.id >= 0) {
      return fetch(`${API.CMM.modelsByMake(make.id, transportId)}&all`)
        .then(r => r.json())
        .then(models => dispatch(setVocabularyField.models(models)));
    }

    return Promise.resolve();
  },
  company: data => async (dispatch, getState, { fetch }) => {
    const {
      partsForm: { vocabulary: { queryobj, typeWork: typeWorkPartsForm } = {} } = {},
      searchForm: {
        selected: { company, makes, typeWork, transport, isOfficial },
      },
      globals: { location },
    } = getState();
    const buf = {
      per_page: 20,
      fields: 'id,title',
    };
    const bufNext = {
      fields: 'id,per_page',
    };
    if (queryobj && queryobj.tags) {
      buf.tags = queryobj.tags;
      bufNext.tags = queryobj.tags;
    }
    if (location) {
      buf.location = location.id;
      bufNext.location = location.id;
    }
    if (transport) {
      buf.transport = transport.id;
    }

    if (data && data.count) {
      if (company) {
        bufNext.title = company.title;
      } else if (bufNext.title) {
        delete bufNext.title;
      }
      if (makes) {
        bufNext.makes = Number(makes.id);
      } else if (bufNext.makes) {
        delete bufNext.makes;
      }
      if (transport) {
        bufNext.transport = Number(transport.id);
      } else if (bufNext.transport) {
        delete bufNext.transport;
      }
      if (isOfficial) bufNext.is_official = isOfficial;
      else delete bufNext.is_official;

      if (typeWork) {
        bufNext.services = typeWork.id;
      } else if (bufNext.services) {
        delete bufNext.services;
      }
      hrefSet({ query: bufNext })(dispatch, null, {});

      await fetch(API.FIRMS.NEW_COUNT(`?${queryString.stringify(bufNext)}`))
        .then(r => r.json())
        .then(dat => {
          dispatch(setVocabularyField.count(dat.count));
        });
    }

    if (!data || (data && data.str)) {
      if (
        data &&
        data.str &&
        typeof data.str === 'string' &&
        data.str.length > 0 &&
        data.str.length < 1000
      ) {
        buf.title = data.str;
      }
      await fetch(API.FIRMS.ALL(`?${queryString.stringify(buf)}`))
        .then(async response => {
          const res = await response.json();
          if (response.ok && res.results) {
            dispatch(setVocabularyField.company(res.results));
          } else {
            dispatch(setVocabularyField.company([]));
          }
        })
        .catch(() => dispatch(setVocabularyField.company([])));
    }
    if (!data || !typeWorkPartsForm) {
      await Promise.all([
        fetch(API.VOCABULARY.makes(1))
          .then(r => r.json())
          .then(dat => dispatch(setVocabularyField.makes(dat))),
        fetch(API.FIRMS.TYPE_WORK())
          .then(r => r.json())
          .then(dat => dispatch(setVocabularyField.typeWork(dat))),
      ]);
    }
  },
};



// WEBPACK FOOTER //
// ./src/shared/actions/partsForm.js